import ReactSkeleton from 'react-loading-skeleton';
import { keyframes, theme, styled, utils } from 'ui/theme';

const loadingAnimation = keyframes`
  100% {
      transform: translateX(100%);
  }
`;

export const radii = {
  large: theme.radii.large,
  medium: theme.radii.medium,
  pill: theme.radii.pill,
  sharp: theme.radii.sharp,
  small: theme.radii.small,
};

export const Skeleton = {
  Component: styled('div')`
    height: 100%;
    width: 100%;

    * {
      height: 100%;
      width: 100%;
    }
  `,

  Skeleton: styled(ReactSkeleton)`
    --animation-duration: ${utils.duration.skeleton}ms;
    --animation-direction: normal;
    --base-color: ${theme.colors.build.mediumLight2};
    --highlight-color: ${theme.colors.build.lightDark1};
    --pseudo-element-display: block; /* Enable animation */

    background-color: var(--base-color);
    border-radius: ${theme.radii.small};
    display: inline-flex;
    line-height: 1;
    overflow: hidden;
    position: relative;
    width: 100%;
    z-index: $base;

    &::after {
      animation-direction: var(--animation-direction);
      animation-duration: var(--animation-duration);
      animation-iteration-count: infinite;
      animation-name: ${loadingAnimation};
      animation-timing-function: ${utils.easing.sharp};
      background: linear-gradient(
          90deg,
          var(--base-color),
          var(--highlight-color),
          var(--base-color)
        )
        no-repeat;
      content: ' ';
      display: var(--pseudo-element-display);
      height: 100%;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      transform: translateX(-100%);
    }
  `,
};
